export default "__VITE_ASSET__BlH3_NwO__"